import React from 'react';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default function DigitalClock({ time, settings, dark }) {
  return (
    <>
      <div className={`text-7xl md:text-8xl font-dm-serif font-bold tracking-tight ${dark ? 'text-white/90' : 'text-gray-800/90'}`}>
        {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
      {settings.showSeconds && (
        <div className={`text-lg font-mono mt-1 ${dark ? 'text-white/30' : 'text-gray-400/60'}`}>
          {String(time.getSeconds()).padStart(2, '0')}
        </div>
      )}
      {settings.showDate && (
        <div className={`text-xl font-rasa mt-4 ${dark ? 'text-white/50' : 'text-gray-500/70'}`}>
          {DAYS[time.getDay()]}, {MONTHS[time.getMonth()]} {time.getDate()}, {time.getFullYear()}
        </div>
      )}
    </>
  );
}
